const regions = [
  {
    id: 1,
    country: "Asia",
    addressLines: ["No 60 Paya Lebar Road", "#11-06 Paya Lebar Square", "Singapore 409051"],
    tel: "Tel:+65631381767",
  },
  {
    id: 2,
    country: "Middle East",
    addressLines: ["The Onyx Tower 1", "Office 910", "P.O.BOx 410870.", "Dubai,United Arab Emirates"],
    tel: "Tel: +971 4399 52 53",
  },
  {
    id: 3,
    country: "United Sates",
    addressLines: ["2700 Post Oak Blvd", "21st Floor", "Houston,TX 77056"],
    tel: "Tel:+1(800)9478211",
  },
  {
    id: 4,
    country: "Europe",
    addressLines: ["Taubstummengasse", "7A-1040 Vienna"],
    tel: "Tel:+4317866318",
  },
];

const innovationCenters = [
  {
    id: 1,
    country: "Malaysia",
    addressLines: ["Unit 27-13, Level 27, Q Sentral,", "Jalan Stesen Sentral 2,", "50470, Kuala Lumpur,", "Malaysia"],
    tel: "Tel:+60322760055",
  },
  {
    id: 2,
    country: "India",
    addressLines: [
      "13th Cross,Sampige Road",
      "4th Floor,#218 JP Royale,",
      "Malleshwaram,Bengaluru",
      "Karnataka 560003",
    ],
    tel: "Tel:91 807 127 9515",
  },
];

const solutions = [
  {
    id: 1,
    title: "solutions",
    contents: [
      {
        text: "everyday performance",
        link: "https://webuat.entomo.co/solutions/everyday-performance/",
      },
      {
        text: "first safety",
        link: "https://webuat.entomo.co/solutions/workplace-safety/",
      },
      {
        text: "everyday insights",
        link: "https://webuat.entomo.co/solutions/everyday-insights/",
      },
      {
        text: "carrers tomorrow",
        link: "https://webuat.entomo.co/solutions/careers-tomorrow/",
      },
    ],
  },
  {
    id: 2,
    title: "entomo",
    contents: [
      {
        text: "platform",
        link: "https://webuat.entomo.co/all-products/entomo/",
      },
      {
        text: "feature",
        link: "https://webuat.entomo.co/all-products/features/",
      },
    ],
  },
];

const inspirations = [
  {
    id: 2,
    title: "inspirations",
    contents: [
      {
        text: "blogs",
        link: "https://webuat.entomo.co/blog/",
      },
      {
        text: "events & webinars",
        link: "https://webuat.entomo.co/resources/events-webinar/",
      },
      {
        text: "success stories",
        link: "https://webuat.entomo.co/resources/success-stories/",
      },
      {
        text: "news & press releases",
        link: "https://webuat.entomo.co/news-press-releases/",
      },
      {
        text: "e books & whitepapers",
        link: "https://webuat.entomo.co/resources/whitepaper-e-book/",
      },
    ],
  },
  {
    id: 3,
    title: "About us",
    contents: [
      {
        text: "why entomo",
        link: "https://entomo.co/about/why-entomo/",
      },
      {
        text: "out team",
        link: "https://entomo.co/about/our-team/",
      },
      {
        text: "contact",
        link: "https://entomo.co/contact/",
      },
      {
        text: "request demo",
        link: "https://entomo.co/request-demo/",
      },
    ],
  },
];

export { regions, innovationCenters, solutions, inspirations };
